// extracted by css-extract-rspack-plugin
var _1 = "source-VE7pa1";
export { _1 as "source" }
